<template>
  <div
    v-if="shellVisible"
    class="
      doc-overview
      documentation-types-panel
      process-info-sidebar
      card-sidebar
      mb-4
      mt-4
    "
    :class="{ 'documentation-types-panel--compact': compact }"
  >
    <h2 v-if="compact" class="title w-full pb-2">{{ panelTitle }}</h2>
    <h2 v-else class="process-info-panel__title">
      <i class="pi pi-list process-info-panel__title-icon" aria-hidden="true" />
      {{ panelTitle }}
    </h2>

    <section v-if="mainPeople.length" class="doc-overview__section">
      <div class="doc-overview__people">
        <DocumentationPersonPanel
          v-for="(person, index) in mainPeople"
          :key="'main-' + person.id"
          :client-id="person.id"
          :name="person.name"
          :img-url="person.imgUrl"
          :process-ids="person.processIds || processIds"
          :compact="compact"
          :default-expanded="index === 0"
        />
      </div>
    </section>

    <section v-if="familyPeople.length" class="doc-overview__section">
      <header class="doc-overview__section-header">
        <i class="pi pi-users" />
        <h4 class="doc-overview__section-title">Documentação dos familiares</h4>
      </header>
      <div class="doc-overview__people">
        <DocumentationPersonPanel
          v-for="(person, index) in familyPeople"
          :key="'family-' + person.id"
          :client-id="person.id"
          :name="person.name"
          :img-url="person.imgUrl"
          :relation-label="person.relationLabel"
          :process-ids="person.processIds || relationProcessIds || processIds"
          :is-relation="familyIsRelation"
          :show-in-client-relations="familyShowInClientRelations"
          :compact="compact"
          :default-expanded="index === 0 && !mainPeople.length"
        />
      </div>
    </section>
  </div>
</template>

<script>
import DocumentationPersonPanel from "./DocumentationPersonPanel.vue";

export default {
  name: "DocumentationOverview",
  components: {
    DocumentationPersonPanel,
  },
  props: {
    mainPeople: { type: Array, default: () => [] },
    familyPeople: { type: Array, default: () => [] },
    processIds: { type: Array, default: () => [] },
    relationProcessIds: { type: Array, default: null },
    familyIsRelation: { type: Boolean, default: true },
    familyShowInClientRelations: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    title: { type: String, default: null },
    hideWhenEmpty: { type: Boolean, default: false },
  },
  computed: {
    shellVisible() {
      if (!this.hideWhenEmpty) {
        return true;
      }
      return this.mainPeople.length > 0 || this.familyPeople.length > 0;
    },
    panelTitle() {
      return this.title || this.$t("documentation_types_title");
    },
  },
};
</script>

<style scoped lang="scss">
.doc-overview {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.doc-overview__section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.doc-overview__section-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #0f172a;

  i {
    font-size: 0.85rem;
  }
}

.doc-overview__section-title {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: #0f172a;
}

.doc-overview__people {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
